<template>
  <label :class="$style.label">
    <span :class="$style.icon">
      <input v-model="model" :class="$style.input" type="checkbox">
      <SvgIcon width="18" height="18" :src="`icon-sprite.svg#checkbox_${modelValue ? '1' : '0'}`" />
    </span>
    <span :class="$style.text">Add for printing</span>
  </label>
</template>

<script>
import { defineComponent } from 'vue';

import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: { SvgIcon },
  props: {
    modelValue: { type: Boolean, default: true },
  },
  emits: ['update:modelValue'],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
});
</script>
<style lang="scss" module>
.label {
  display: flex;
  align-items: center;
  user-select: none;
}

.input {
  opacity: 0;
  position: absolute;
}
.icon {
  &,
  & > * {
    width: 18px;
    height: 18px;
  }
  svg {
    pointer-events: none;
  }
}
.text {
  margin-left: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #3f4757;
}
</style>
